interface ISiteLink
    extends ISiteButton {
    action: string;
}

class SiteLink
    extends QueryElement<HTMLElement>  {
    
    constructor(owner: ISiteCard, link: ISiteLink, element: HTMLElement) {
        super(element);

        let linkInfo = link.action.split('/');
        let linkActionInfo : IActionInfo = {
            module: linkInfo.shift() || "",
            controller: linkInfo.shift() || "",
            action: linkInfo.shift() || "",
            id: linkInfo.join("/")
        };
        let linkAction: IActionLink = {
            actionInfo: linkActionInfo
        };
        let linkActionType : IActionTypeRequest = {
            actionLink: linkAction,
            type: "Request"
        };
        let action = SiteAction.create(owner, linkActionType);

        this.on("click", async(a) => {
            if (action != null)
                action.execute();
            
            a.stop();
        });
    }
}